'use client';!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:qogita-web-sellers":true});}catch(e){}}();

import { useOptionalDrawerContext } from '@qogita/ui/v2/drawer'
import { LogoutButton } from 'src/components/logout-button'

export function SidebarLogoutButton() {
  const { closeDrawer } = useOptionalDrawerContext()

  return (
    <LogoutButton variant="text" clickAction={closeDrawer}>
      Sign Out
    </LogoutButton>
  )
}
